import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleOpenArrowLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M7.561,9.75l1.97,1.97c.293,.293,.293,.768,0,1.061-.146,.146-.338,.22-.53,.22s-.384-.073-.53-.22l-3.25-3.25c-.293-.293-.293-.768,0-1.061l3.25-3.25c.293-.293,.768-.293,1.061,0s.293,.768,0,1.061l-1.97,1.97h9.401c-.38-4.061-3.804-7.25-7.962-7.25C4.589,1,1,4.589,1,9s3.589,8,8,8c4.158,0,7.582-3.189,7.962-7.25H7.561Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleOpenArrowLeftFill18.js.map